<template>
	<div>
		<div class="is-flex is-flex-direction-row is-full-width is-justify-content-space-between is-align-items-center">
			<div class="is-flex-grow-3">
				<p class="tittleContent"> {{ selectedTypeFile.label }} de
					<span class="is-capitalized">
						{{ selectedDate.month }}
					</span> {{ selectedDate.year }}
				</p>
				<p class="subTittleContent mb-1">
					{{ selectedTypeFile.subTittle }}
				</p>
			</div>
		</div>

		<div class="is-flex is-flex-direction-row p-4 template_box">
			<div style="flex-basis: 5%;" class="mr-1">
				<span class="info_circle">
					<InfoCircle class="" />
				</span>
			</div>
			<div style="flex-basis: 95%;">
				<p class="tittle"> {{ selectedTypeFile.alertTittle }} </p>
				<p class="sub_tittle"> {{ selectedTypeFile.alertSubTittle }} </p>
				<p v-if="ledgerNotice" class="sub_tittle ledger_notice mt-2">{{ ledgerNotice }}</p>
				<div class="is-flex mt-3">
					<div class="download_btn is-flex is-justify-content-start is-clickable"
						@click="$emit('download-template')">
						<DownloadFile />
						<span class="text_month ml-1">Descargar Plantilla</span>
					</div>
					<div v-if="selectedTypeFile.value != 'finiquitos-clf'"
						class="download_btn is-flex is-justify-content-start ml-2" :class="{
							'is-disabled-local': !previousMonth || !previousMonth.id,
							'is-clickable': previousMonth && previousMonth.id
						}" @click="$emit('download-file', {
							url: previousMonth.url_drive,
							name: previousMonth.file_name,
							year: previousMonth.year_file,
							month: previousMonth.month_file,
						})">
						<DownloadFile />
						<span class="text_month ml-1">Mes anterior</span>
					</div>
				</div>
			</div>
		</div>

		<div class="is-flex is-flex-direction-row mt-4 p-4 file_box"
			:class="[isError ? 'box_color_error' : 'box_color_normal', { 'is-disabled-local': isUploadingFile }]">
			<div style="flex-basis: 5%;" class="mr-1">
				<span class="">
					<FileXLS v-if="!isError && isFileUploaded" />
					<Page v-if="isError || !isFileUploaded" />
				</span>
			</div>
			<div style="flex-basis: 95%;" class="is-flex is-flex-direction-row">
				<div style="min-width: 40%;" class="is-flex is-flex-direction-column is-justify-content-center">
					<p v-if="!isFileUploaded" class="tittle">Subir {{ selectedTypeFile.label }} </p>
					<p v-if="isFileUploaded" class="tittle">
						{{ selectedMonthFile.file_name }}
					</p>
					<p v-if="!isError && isFileUploaded" class="sub_tittle">
						Archivo cargado: {{ getDateByFormat(selectedMonthFile.update_at, "D, MMMM YYYY") }}
						| Tamaño: {{ selectedMonthFile.size_kb }} KB
					</p>
					<p v-if="isError && isFileUploaded" class="sub_tittle">Error en el archivo</p>
				</div>
				<div class="is-full-width is-flex is-justify-content-end is-align-items-center">
					<span class="download_btn is-flex is-justify-content-center is-clickable mr-2"
						@click="$emit('request-pick')">
						<span class=" mr-2">
							<Refresh v-if="isFileUploaded" class="svg_icon" />
							<UploadFile v-if="!isFileUploaded" class="svg_icon" />
						</span>
						<span v-if="isFileUploaded">Actualizar</span>
						<span v-else>Subir Documento</span>
					</span>
					<span v-if="isFileUploaded"
						@click="$emit('download-file', {
							url: selectedMonthFile.url_drive,
							name: selectedMonthFile.file_name,
							year: selectedDate.year,
							month: selectedDate.month,
						})"
						class="download_btn is-clickable mr-2">
						<DownloadFile class="svg_icon" />
					</span>
					<span v-if="isFileUploaded" @click="$emit('delete-file')"
						class="download_btn is-clickable">
						<Trash class="svg_icon" />
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import DownloadFile from "@/components/svg/DownloadFile.vue";
import FileXLS from "@/components/svg/FileXLS.vue";
import InfoCircle from "@/components/svg/InfoCircle.vue";
import Page from "@/components/svg/Page.vue";
import Refresh from "@/components/svg/Refresh.vue";
import Trash from "@/components/svg/Trash.vue";
import UploadFile from "@/components/svg/UploadFile.vue";

export default {
	name: "UploadFilePanel",
	components: { DownloadFile, FileXLS, InfoCircle, Page, Refresh, Trash, UploadFile },
	props: {
		selectedTypeFile: { type: Object, required: true },
		selectedDate: { type: Object, required: true },
		selectedMonthFile: { type: Object, default: () => ({}) },
		previousMonth: { type: Object, default: () => ({}) },
		isError: { type: Boolean, default: false },
		isFileUploaded: { type: [Boolean, String, Number], default: false },
		isUploadingFile: { type: Boolean, default: false },
		// Aviso fijo de una empresa con mayor (vacío = sin aviso).
		ledgerNotice: { type: String, default: "" },
	},
	methods: {
		getDateByFormat(date, format) {
			const newDate = moment(date);
			return newDate.format(format);
		},
	},
};
</script>

<style scoped lang="scss">
.svg_icon {
	width: 20px;
	height: 20px;
	margin-bottom: -4px;
}

.tittleContent {
	color: var(--Gray-900, #101828);
	font-size: 18px;
	font-weight: 600;
	line-height: 28px;
}

.subTittleContent {
	color: var(--Gray-600, #475467);
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
}

.template_box {
	border-radius: 12px;
	border: 1px solid #90FFF5;
	background: #EFFEFD;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

	.info_circle {
		width: 40px;
		height: 40px;
		background-color: #1DE4E1;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.tittle {
		color: #002E33;
		font-size: 14px;
		font-weight: 600;
		line-height: 20px;
	}
}

.file_box {
	border-radius: 12px;

	.tittle {
		color: var(--Gray-700, #344054);
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
	}
}

.box_color_normal {
	border: 1px solid var(--Gray-200, #EAECF0);
	background-color: var(--Base-White, #FFF);
}

.box_color_error {
	border: 1px solid #FECDCA;
	background-color: #FEF3F2;
}

.ledger_notice {
	font-weight: 600;
}

.sub_tittle {
	color: var(--Gray-600, #475467);
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
}

.download_btn {
	border-radius: 8px;
	border: 1px solid var(--Gray-300, #D0D5DD);
	background: var(--Base-White, #FFF);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	padding: 10px 14px;
	max-width: fit-content;

	color: var(--Gray-700, #344054);
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
}
</style>
